import React from 'react'
import styled from 'styled-components'
import { Color, Size } from '../../../../../const'
import { Button } from '../../../../shard'
import WrapperLink from 'components/shard/WrapperLink'

function IdEditMobile() {
  return (
    <Content>
      <TextArea>
        <Text>
          ID変更が完了しました。
          <br />
          新しいIDで再度ログインしてください。
        </Text>
      </TextArea>
      <Separator />
      <ButtonWrapper>
        <NextLink to="/login">
          <Button type="button" primary>
            ログインする
          </Button>
        </NextLink>
      </ButtonWrapper>
    </Content>
  )
}

const Content = styled.div`
  padding: 18px 0 20px 0;
`
const TextArea = styled.div`
  padding: 0 20px 346px 20px;
  display: flex;
  justify-content: center;
`
const Text = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.BIG};
  text-align: center;
`
const ButtonWrapper = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: center;
`
const NextLink = styled(WrapperLink)`
  text-decoration: none;
`
const Separator = styled.hr`
  border-top: 1px solid ${Color.LINE.NORMAL};
  border-bottom: 0;
  margin: 0;
`

export default IdEditMobile
